// MoneyCell — THE money renderer. `$` pinned left, digits right, tabular figures.
//
// ── CENTS ARE FOR UNIT PRICES ONLY (Alex, 2026-08-14) ──────────────────────────
// `unit` → two decimals ($5.50/kg, $42.00/hr): a unit price IS the cents, and
// rounding one changes the answer.
// Default → NO decimals ($121,580,000): on an extended amount the cents are noise
// that costs three characters in a 100px column.
//
// ⚠ THIS REPLACED A COMPACT ≥$1M FORM ("$121.58M"), and the replacement was Alex's
// call on the same problem. The compact form existed because "a 9-digit total once
// read as thousands" (2026-07-02) — a real misread, and clipping was the cause. But
// compacting fixes clipping by DESTROYING precision on screen and hiding the true
// number in a tooltip nobody hovers. Dropping the cents buys back three characters
// while every digit that matters stays visible. Alex, 2026-08-14: "I do not want
// this, it must remain the same. Only drop the two digit unless it is unit price."
//
// The original problem has NOT gone away, so it is worth naming what still guards
// it: the digits are tabular and `whiteSpace: nowrap`, so a too-narrow column
// overflows visibly rather than reflowing into something readable-but-wrong.
const _fmtCents = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const _fmtWhole = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

// ⚠ NO fontSize PROP (2026-10-12) — same reason as HourCell: a per-call size is how
// the components-grid totals drifted. One size, here; check-style.mjs fails any call
// site that passes fontSize to a component.
const fontSize = 'var(--fs-small)';

export default function MoneyCell({ n, bold, color, unit = false }) {
  if (n == null) return null;
  const num = Number(n);
  if (!Number.isFinite(num)) return null;
  const fw = bold ? 600 : undefined;
  const text = (unit ? _fmtCents : _fmtWhole).format(num);
  return (
    <span
      // The exact cents stay reachable on a rounded amount — the number on screen is
      // the one to read, this is for when someone needs to reconcile to the penny.
      title={unit ? undefined : `$${_fmtCents.format(num)}`}
      style={{ display: 'flex', width: '100%', alignItems: 'baseline', fontVariantNumeric: 'tabular-nums' }}
    >
      <span style={{ flexShrink: 0, fontSize, fontWeight: fw, color }}>$</span>
      <span style={{ flex: 1, textAlign: 'right', fontSize, fontWeight: fw, color, whiteSpace: 'nowrap' }}>
        {text}
      </span>
    </span>
  );
}
